module.exports = __webpack_public_path__ + "static/media/package.157d03a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/package.svg
// module id = 272
// module chunks = 0